export const handleErrorNotification = (error: any, notify: any) => {
    if (error.response?.data?.message) {
        notify("error", error.response.data.message);
    }
};